import { goToProposeTime as navigateToProposeTime } from '@/utils/referralPoolProposeFlow'

export default {
    methods: {
        goToProposeTime(referralOrData, referralType = 'received') {
            navigateToProposeTime(this.$router, this.$auth, referralOrData, referralType)
        },
    },
}
